var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-center" }, [
    _c(
      "div",
      [
        _c("v-icon", { staticClass: "mr-4", attrs: { large: "" } }, [
          _vm._v(_vm._s(_vm.icon))
        ])
      ],
      1
    ),
    _c("div", { staticClass: "title-header" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }